import { CORPORATE_REGISTRATION_NUMBERS, TAX_SINGO_DATA_TYPE_LIST, TAX_SINGO_REPETITION_TYPE_LIST, TAX_SINGO_STATUS_LIST } from "../../constants/TaxPortal/TAX_SINGO";

export const getTaxSingoStatus = (t) => {
  if (!t) t = 'pending'
  return TAX_SINGO_STATUS_LIST.find(
    (type) => type.label === t || type.value === t
  )
}
export const getTaxSingoRepetitionType = (t) => {
  if (!t) t = 'null'
  return TAX_SINGO_REPETITION_TYPE_LIST.find(
    (type) => type.label === t || type.value === t
  )
}

export const getTaxSingoDataType = (t) => {
  if (!t) t = 'default'
  return TAX_SINGO_DATA_TYPE_LIST.find(
    (type) => type.value === t
  )
}


export const isCorporateRegistration = (bsno) => {
  const digits = bsno.slice(3, 5);
  return CORPORATE_REGISTRATION_NUMBERS.includes(digits);
}


export const taxSingoFileConverter = (props = {}) => {
  const { data, scheduled, taxpayer, name } = props;
  const base64String = Buffer.from(data, 'hex').toString('base64');
  const documentName = scheduled.name;
  const linkSource = `data:application/pdf;base64,${base64String}`;
  const fileName = `${documentName}_${taxpayer.companyName}${name ? `_${name}` : ''}.pdf`;
  return {
    linkSource,
    fileName
  }
}